<template>
  <v-card>
    <v-img :src="imageSrc" :aspect-ratio="1.910828025477707">
      <v-layout fill-height align-center justify-center ma-0>
        <v-progress-circular
          v-if="loading"
          indeterminate
          color="grey lighten-5"
        ></v-progress-circular>
      </v-layout>
    </v-img>
    <v-card-title>
      <h1>Share your GSMG experience</h1>
    </v-card-title>
    <v-card-text>
      <p>
        <v-text-field
          ref="social-media-text"
          v-model="textSocialMedia"
          append-outer-icon="fas fa-copy"
          prepend-icon="fas fa-hashtag"
          box
          label="Social Media"
          type="text"
          @click:append-outer="copyCode('social-media-text')"
        ></v-text-field>
      </p>
      <p>
        <v-text-field
          ref="image-url"
          v-model="textImageUrl"
          append-outer-icon="fas fa-copy"
          prepend-icon="fas fa-image"
          box
          label="Image URL"
          type="text"
          @click:append-outer="copyCode('image-url')"
        ></v-text-field>
      </p>
      <p>
        <ShareNetwork
          network="twitter"
          :url="publicUrl"
          :title="socialMediaTitle"
          twitter-user="GSMG_Bot"
          hashtags="GSMG,cryptotrading,algotrading"
          :style="{ backgroundColor: '#1da1f2' }"
        >
          <i class="fab fah fa-lg fa-twitter"></i>
          <span>Share on Twitter</span>
        </ShareNetwork>

        <ShareNetwork
          network="telegram"
          :url="publicUrl"
          :title="socialMediaTitle"
          :style="{ backgroundColor: '#0088cc' }"
        >
          <i class="fab fah fa-lg fa-telegram-plane"></i>
          <span>Share on Telegram</span>
        </ShareNetwork>

        <ShareNetwork
          network="facebook"
          :url="publicUrl"
          :quote="socialMediaTitle"
          :title="socialMediaTitle"
          hashtags="GSMG,cryptotrading,algotrading"
          :style="{ backgroundColor: '#1877f2' }"
        >
          <i class="fab fah fa-lg fa-facebook-f"></i>
          <span>Share on Facebook</span>
        </ShareNetwork>
      </p>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat="flat" @click.native="$emit('close-dialog')">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<style>
a[class^="share-network-"] {
  color: #ffffff;
  border-radius: 3px;
  overflow: hidden;
  display: inline-block;
  align-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0 10px 10px 0;
  width: 180px;
}
a[class^="share-network-"] .fah {
  background-color: rgba(0, 0, 0, 0.2);
  padding: 10px;
  /*flex: 0 1 auto;*/
}
a[class^="share-network-"] span {
  padding: 0 10px;
  /*flex: 1 1 0%;*/
  font-weight: 500;
}
</style>

<script>
import axios from "axios";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";
import swal from "sweetalert2";
import { bugsnagClient } from "~/plugins";
import {mapGetters} from "vuex";

export default {
  name: "Share",
  props: {
    metric: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      metadata: [],
      loading: true,
      textSocialMedia: null,
      textImageUrl: null,
      imageUrl: null,
      imageSrc: null,
      publicUrl: "https://gsmg.io/"
    };
  },
  watch: {
    metric() {
      this.reset();
      this.loadData();
    },
    publicUrl() {
      if (this.loading) {
        return;
      }

      this.textSocialMedia = `${this.socialMediaTitle} #GSMG #cryptotrading #algotrading ${this.publicUrl}`;
      this.textImageUrl = this.imageUrl;
    }
  },
  created() {
    this.reset();
  },
  mounted() {
    this.loadData();
  },
  computed: {
    ...mapGetters({
      themeDark: "settings/darkmode"
    }),
    socialMediaTitle() {
      return "A.I. is taking over, look at it taking over my life. No pain just gain.";
    }
  },
  methods: {
    async loadData() {
      try {
        const { data } = await axios.post("/api/v1/generate-share-image", {
          metric: this.metric,
          tz: moment.tz.guess()
        });

        this.loading = false;
        this.imageSrc = "data:image/png;base64," + data.base64;
        this.publicUrl = data.url;
        this.imageUrl = data.image_url;
        this.metadata = data.metadata;
      } catch (error) {
        await swal({
          title: "Problem getting an image to share",
          showConfirmButton: false,
          showCloseButton: true,
          customClass: this.themeDark ? "swal-type-error-dark" : "swal-type-error",
          imageUrl: "/img/popup_img_error.png",
          imageHeight: 80,
          imageWidth: 80
        });

        bugsnagClient.notify(error);
      }
    },
    reset() {
      this.loading = true;
      this.textSocialMedia = "Loading..";
      this.textImageUrl = "Loading..";
      this.imageUrl = null;
      this.publicUrl = "https://gsmg.io";
      this.metadata = [];
      this.imageSrc =
        "data:image/jpeg;base64,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";
    },
    copyCode(ref) {
      const textToCopy = this.$refs[ref].$el.querySelector("input");
      textToCopy.select();
      document.execCommand("copy");
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// resources/js/components/dashboard/Share.vue